import styled from 'styled-components';
import { Typography } from '@mui/material';
import { localizeDate } from '../../../utils/datetime';
import { Flex } from '../../Flex';
import { QuotaScope } from '../types';

const formatReset = (
  scope: QuotaScope,
  resetsAt?: string | null,
): string | null => {
  if (!resetsAt) return null;
  const resetDate = localizeDate(resetsAt);
  if (!resetDate.isValid()) return null;
  return scope === 'monthly' ? resetDate.format('LL') : resetDate.format('LT');
};

export const buildQuotaMessage = (
  scope: QuotaScope,
  resetsAt?: string | null,
): string => {
  const resetLabel = formatReset(scope, resetsAt);
  if (scope === 'monthly') {
    return resetLabel
      ? `Monthly token limit used. Resets on ${resetLabel}.`
      : 'Monthly token limit used.';
  }
  return resetLabel
    ? `Daily token limit used. Resumes at ${resetLabel}.`
    : 'Daily token limit used.';
};

const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  align-self: center;
  width: calc(100% - 14px);
  border-radius: 6px 6px 0 0;
  background: ${({ theme }) => theme.palette.common.lightOrange};
  box-shadow: 0px -6px 15px -5px rgba(0, 0, 0, 0.03);
`;

const Message = styled(Typography).attrs({ component: 'div' as const })`
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.12px;
  color: ${({ theme }) => theme.palette.common.gray2};
  text-align: center;
  width: 100%;
  padding: 2px 24px;
  box-sizing: border-box;
  margin: 0;
`;

type Props = {
  scope?: QuotaScope;
  resetsAt?: string | null;
};

const QuotaBanner = ({ scope = 'daily', resetsAt }: Props) => (
  <Wrapper>
    <Message>{buildQuotaMessage(scope, resetsAt)}</Message>
  </Wrapper>
);

export default QuotaBanner;
